<template>
  <div
    class="mt-6 flex justify-start items-start flex-col w-full h-auto bg-transparent overflow-visible"
  >
    <report-selector label="Invoices" v-model="selection">
      <option v-for="i in invoicesOrdered" :key="i.id" :value="i.id">
        {{
          `${toDateString(eitherDate(i))} – ${vendorName(i.vendorId)}${
            i.completed ? '' : ' (incomplete)'
          }`
        }}
      </option>
    </report-selector>

    <div v-if="doc" class="relative mt-3">
      <s-button class="shadow-lg" @click.stop="actionsOpen = !actionsOpen">
        Actions
      </s-button>
      <div
        v-if="actionsOpen"
        class="absolute left-0 mt-1 w-52 bg-white rounded-lg shadow-lg py-1 z-50 border border-gray-200"
      >
        <button
          v-if="(isManager || isAdmin) && productsNotInInvoice.length > 0"
          @click="$modal.show('modal--selection', { list: productsNotInInvoice, display: productName, invoiceId: selection }); actionsOpen = false"
          class="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
        >
          Add Item
        </button>
        <button
          v-if="isManager || isAdmin"
          @click="toggleInvoiceCompletedByInvoiceId(selection); actionsOpen = false"
          class="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
        >
          Toggle Completed
        </button>
        <button
          v-if="(isAdmin || isManager) && doc.downloadURL"
          @click="viewScan(); actionsOpen = false"
          class="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
        >
          View Scan
        </button>
        <button
          v-if="isAdmin || isManager"
          @click="downloadCsv(invoiceCsvByInvoiceId(selection)); actionsOpen = false"
          class="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
        >
          Export
        </button>
        <button
          v-if="isDeveloper"
          @click="newEmail(selection); actionsOpen = false"
          class="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
        >
          Resubmit
        </button>
        <button
          v-if="isManager || isAdmin"
          @click="$modal.show('modal--selection-vendor', { list: vendorsActive, display: vendorName }); actionsOpen = false"
          class="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
        >
          Create
        </button>
        <button
          v-if="isAdmin"
          @click="deleteInvoice(selection); actionsOpen = false"
          class="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition-colors"
        >
          Delete
        </button>
      </div>
    </div>
    <div v-if="actionsOpen" class="fixed inset-0 z-40" @click="actionsOpen = false" />

    <div
      v-if="doc"
      class="w-full mt-3 sm:mt-6 text-left flex flex-row text-base justify-between"
    >
      <div class="flex flex-row">
        <span class="font-bold">
          <div>Vendor:</div>
          <div>Invoice Number:</div>
          <div v-if="doc.orderDate && doc.orderDate.seconds">Order Date:</div>
          <div>Delivery Date:</div>
          <div>Invoice Date:</div>
        </span>
        <span class="mx-2 sm:mx-6">
          <div class="text-center">{{ vendorName(doc.vendorId) }}</div>

          <div class="bg-yellow-200 focus-within:bg-yellow-300">
            <input
              type="text"
              class="w-24 sm:w-32 text-center bg-transparent no-arrow"
              :value="doc.invoiceNumber"
              @change="
                e =>
                  updateInvoiceNumberByInvoiceId({
                    invoiceId: selection,
                    invoiceNumber: e.target.value
                  })
              "
            />

            <!-- {{ doc.invoiceNumber ? doc.invoiceNumber : 'Not Provided' }} -->
          </div>
          <div class="bg-yellow-200 focus-within:bg-yellow-300">
            <v-date-picker
              v-model.lazy="localOrderDate"
              :is-required="true"
              :popover="{
                placement: $screens({ default: 'bottom-end', sm: 'bottom' }),
                positionFixed: true,
                class: 'z-50',
                visibility: 'click'
              }"
            >
              <template #default="{ inputValue, inputEvents }">
                <input
                  :value="inputValue"
                  v-on="inputEvents"
                  class="w-24 sm:w-32 text-center bg-transparent no-arrow"
                  :placeholder="
                    doc.orderDate
                      ? doc.orderDate.toDate().toLocaleDateString()
                      : 'Required'
                  "
                  readonly
                />
              </template>
            </v-date-picker>
            <!-- :input-props="{
                class: 'w-24 sm:w-32 text-center bg-transparent no-arrow',
                placeholder: 'Required',
                readonly: true
              }" -->

            <!-- :timezone="" -->
          </div>
          <div class="bg-yellow-200 focus-within:bg-yellow-300">
            <v-date-picker
              v-model.lazy="localDeliveryDate"
              :is-required="true"
              :popover="{
                placement: $screens({ default: 'bottom-end', sm: 'bottom' }),
                positionFixed: true,
                class: 'z-50',
                visibility: 'click'
              }"
            >
              <template #default="{ inputValue, inputEvents }">
                <input
                  :value="inputValue"
                  v-on="inputEvents"
                  class="w-24 sm:w-32 text-center bg-transparent no-arrow"
                  :placeholder="
                    doc.orderDate
                      ? doc.orderDate.toDate().toLocaleDateString()
                      : 'Required'
                  "
                  readonly
                />
              </template>
            </v-date-picker>
          </div>
          <div class="bg-yellow-200 focus-within:bg-yellow-300">
            <v-date-picker
              v-model.lazy="localInvoiceDate"
              :is-required="true"
              :popover="{
                placement: $screens({ default: 'bottom-end', sm: 'bottom' }),
                positionFixed: true,
                class: 'z-50',
                visibility: 'click'
              }"
            >
              <template #default="{ inputValue, inputEvents }">
                <input
                  :value="inputValue"
                  v-on="inputEvents"
                  class="w-24 sm:w-32 text-center bg-transparent no-arrow"
                  :placeholder="
                    doc.orderDate
                      ? doc.orderDate.toDate().toLocaleDateString()
                      : 'Required'
                  "
                  readonly
                />
              </template>
            </v-date-picker>
          </div>
        </span>
      </div>
      <div class="flex flex-row">
        <span class="font-bold">
          <div>Fees:</div>
          <div>Tax:</div>
          <div>Total:</div>
          <div v-if="isAnyItemReturned" class="italic">Refund:</div>
        </span>
        <span class="mx-6">
          <div class="bg-yellow-200 focus-within:bg-yellow-300">
            <!-- <input
              type="number"
              class="w-24 text-center bg-transparent no-arrow"
              :value="doc.fees"
              @change="
                e =>
                  updateFeesByInvoiceId({
                    invoiceId: selection,
                    fees: e.target.valueAsNumber
                  })
              "
            /> -->
            <money
              class="w-24 text-center bg-transparent no-arrow"
              v-model.lazy="doc.fees"
              @change.native="
                e => {
                  if (e.isTrusted)
                    updateFeesByInvoiceId({
                      invoiceId: selection,
                      fees: doc.fees
                    })
                }
              "
              v-bind="moneyConfig"
              autocomplete="off"
            />
          </div>
          <!-- <div>${{ floatify(doc.fees) }}</div> -->
          <div class="bg-yellow-200 focus-within:bg-yellow-300">
            <!-- <input
              type="number"
              class="w-24 text-center bg-transparent no-arrow"
              :value="doc.tax"
              @change="
                e =>
                  updateTaxByInvoiceId({
                    invoiceId: selection,
                    tax: e.target.valueAsNumber
                  })
              "
            /> -->
            <money
              class="w-24 text-center bg-transparent no-arrow"
              v-model.lazy="doc.tax"
              @change.native="
                e => {
                  if (e.isTrusted)
                    updateTaxByInvoiceId({
                      invoiceId: selection,
                      tax: doc.tax
                    })
                }
              "
              v-bind="moneyConfig"
              autocomplete="off"
            />
          </div>
          <!-- <div>${{ floatify(doc.tax) }}</div> -->
          <div class="text-center">{{ doc.totalCost | usd }}</div>
          <div v-if="isAnyItemReturned" class="text-center italic">
            {{ refundAmount | usd }}
          </div>
        </span>
      </div>
    </div>

    <report-table v-if="doc">
      <div>
        <table
          class="text-center w-full border-collapse overflow-scroll leading-none"
        >
          <thead>
            <tr>
              <th
                class="py-1 px-2 whitesapce-no-wrap bg-white font-bold text-base text-left text-gray-800"
              >
                Product
              </th>
              <th
                class="py-1 px-2 whitesapce-no-wrap bg-white font-bold text-base text-center text-gray-800"
              >
                Cost History
              </th>
              <th
                class="py-1 px-2 whitesapce-no-wrap bg-white font-bold text-base text-center text-gray-800"
              >
                Entered
              </th>
              <th
                class="py-1 px-2 whitesapce-no-wrap bg-white font-bold text-base text-center text-gray-800"
              >
                Ordered
              </th>
              <th
                class="py-1 px-2 whitesapce-no-wrap bg-white font-bold text-base text-center text-gray-800"
              >
                Received
              </th>

              <th
                v-if="isAnyItemWrongAmount"
                class="py-1 px-2 whitesapce-no-wrap bg-white font-bold text-base text-center text-gray-800"
              >
                Billed
              </th>
              <th
                class="py-1 px-2 whitespace-nowrap bg-white font-bold text-base text-center text-gray-800"
              >
                Item Cost
              </th>
              <th
                class="py-1 px-2 whitesapce-no-wrap bg-white font-bold text-base text-center text-gray-800"
              >
                Total Cost
              </th>
              <th
                class="py-1 px-2 whitesapce-no-wrap bg-white font-bold text-base text-left text-gray-800"
              >
                Action
              </th>
              <th
                v-if="isAnyItemReturned"
                class="py-1 px-2 whitesapce-no-wrap bg-white font-bold text-base text-center text-gray-800"
              >
                Qty Returned
              </th>
              <th
                v-if="isAnyItemReturned"
                class="py-1 px-2 whitesapce-no-wrap bg-white font-bold text-base text-left text-gray-800"
              >
                Reason
              </th>
              <th
                class="py-1 px-2 whitesapce-no-wrap bg-white font-bold text-base text-left text-gray-800"
              ></th>
            </tr>
          </thead>
          <tbody>
            <template
              v-for="i in sortProductIdsByProductName(productsByInvoiceId(selection))"
            >
            <tr
              :key="`${i}-reportOrderItem`"
              class="px-2 hover:bg-gray-100 hover:font-bold text-center"
              :class="{ 'bg-gray-100': reassigningProductId === i }"
            >
              <td
                class="py-1 px-2 border-b text-left"
                @click="$modal.show('modal--product-prices', { id: doc[i].id })"
              >
                {{ doc[i].name }}
              </td>
              <td
                class="border-b text-left"
                @click="$modal.show('modal--product-prices', { id: doc[i].id })"
              >
                <sparkline
                  v-if="
                    productsCosts[doc[i].id] &&
                      productsCosts[doc[i].id].length > 1
                  "
                  :data="[
                    ...productsCosts[doc[i].id].map(dataPoint =>
                      Math.abs(dataPoint.cost).toFixed(2)
                    )
                  ]"
                ></sparkline>
              </td>
              <td class="py-1 px-2 border-b">
                {{ doc[i].amountEntered }}
              </td>
              <td class="py-1 px-2 border-b">
                {{ doc[i].amountOrdered }}
              </td>
              <td
                class="py-1 px-2 w-12 bg-yellow-200 focus-within:bg-yellow-300 border-b"
              >
                <input
                  type="number"
                  class="text-center bg-transparent w-full"
                  :value="doc[i].amountReceived"
                  @change="
                    e =>
                      updateAmountReceivedByInvoiceIdByItemId({
                        invoiceId: selection,
                        productId: i,
                        amountReceived: e.target.valueAsNumber || 0
                      })
                  "
                />
              </td>

              <!-- <td
                v-if="isAnyItemWrongAmount"
                class="py-1 px-2 border-b"
              >
                {{ doc[i].amountBilled }}
              </td> -->
              <td
                v-if="
                  isAnyItemWrongAmount &&
                    String(doc[i].action) ==
                      'Discrepancy: Wrong Number Received'
                "
                class="py-1 px-2 w-12 bg-yellow-200 focus-within:bg-yellow-300 border-b"
              >
                <input
                  type="number"
                  class="text-center bg-transparent w-full"
                  :value="doc[i].amountBilled"
                  @change="
                    e =>
                      updateAmountBilledByInvoiceIdByItemId({
                        invoiceId: selection,
                        productId: i,
                        amountBilled: e.target.valueAsNumber || 0
                      })
                  "
                />
              </td>
              <td
                v-else-if="isAnyItemWrongAmount"
                class="py-1 px-2 border-b"
              ></td>
              <td
                class="py-1 px-2 w-16 bg-yellow-200 focus-within:bg-yellow-300 border-b"
              >
                <!-- <input
                  type="number"
                  class="text-center bg-transparent w-full no-arrow"
                  :value="doc[i].cost"
                  @change="
                    e =>
                      updateCostByInvoiceIdByItemId({
                        invoiceId: selection,
                        productId: i,
                        cost: e.target.valueAsNumber
                      })
                  "
                /> -->
                <money
                  class="w-full text-center bg-transparent no-arrow"
                  v-model.lazy="doc[i].cost"
                  @change.native="
                    e => {
                      if (e.isTrusted)
                        updateCostByInvoiceIdByItemId({
                          invoiceId: selection,
                          productId: i,
                          cost: doc[i].cost
                        })
                    }
                  "
                  v-bind="moneyConfig"
                  autocomplete="off"
                />
              </td>
              <!-- <td class="py-1 px-2 border-b">
                {{ i.cost ? `$ ${floatify(i.cost)}` : '' }}
              </td> -->
              <td class="py-1 px-2 border-b whitespace-nowrap">
                {{ doc[i].totalCost ? format(doc[i].totalCost) : '' }}
              </td>
              <td class="py-1 px-1 border-b text-left">
                <div class="relative w-64">
                  <select
                    class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 pr-8 rounded leading-tight focus:outline-none focus:shadow-outline focus:bg-white focus:border-gray-500"
                    :id="`inputInvoiceAction_${i}`"
                    :ref="`inputInvoiceAction_${i}`"
                    @click.stop
                    @focus.stop="$emit('focused', i)"
                    :value="doc[i].action"
                    @change="
                      e =>
                        updateActionByInvoiceIdByItemId({
                          invoiceId: selection,
                          productId: i,
                          action: e.target.value
                        })
                    "
                  >
                    <option
                      v-for="action in settingsInvoiceActions"
                      :key="action"
                      v-text="action"
                    />
                  </select>
                  <div
                    class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                  >
                    <svg
                      class="fill-current h-4 w-4"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                    >
                      <path
                        d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                      />
                    </svg>
                  </div>
                </div>
              </td>
              <td
                v-if="
                  isAnyItemReturned &&
                    doc[i].action &&
                    String(doc[i].action).startsWith('Returned')
                "
                class="py-1 px-2 w-12 bg-yellow-200 focus-within:bg-yellow-300 border-b"
              >
                <input
                  type="number"
                  class="text-center bg-transparent w-full"
                  :value="doc[i].amountReturned || 0"
                  @change="
                    e =>
                      updateAmountReturnedByInvoiceIdByItemId({
                        invoiceId: selection,
                        productId: i,
                        amountReturned: e.target.valueAsNumber
                      })
                  "
                />
                <!-- {{ doc[i].returnQty || doc[i].amountReturned || 0 }} -->
              </td>
              <td v-else-if="isAnyItemReturned" class="py-1 px-2 border-b" />
              <td
                v-if="
                  isAnyItemReturned &&
                    doc[i].action &&
                    String(doc[i].action).startsWith('Returned')
                "
                class="py-1 px-2 w-64 bg-yellow-200 focus-within:bg-yellow-300 border-b text-left"
              >
                <!-- {{ doc[i].returnReason }} -->
                <input
                  type="text"
                  class="text-left bg-transparent w-64 truncate"
                  :value="doc[i].returnReason"
                  @change="
                    e =>
                      updateReturnReasonByInvoiceIdByItemId({
                        invoiceId: selection,
                        productId: i,
                        returnReason: e.target.value
                      })
                  "
                />
              </td>
              <td v-else-if="isAnyItemReturned" class="py-1 px-2 border-b" />
              <td class="py-1 px-2 border-b">
                <button
                  v-if="(isAdmin || isManager) && reassigningProductId !== i"
                  @click="startReassign(i)"
                  class="text-xs text-gray-400 hover:text-gray-700 underline whitespace-nowrap"
                >
                  Reassign
                </button>
                <button
                  v-else-if="reassigningProductId === i"
                  @click="cancelReassign()"
                  class="text-xs text-gray-500 hover:text-gray-700 underline whitespace-nowrap"
                >
                  Cancel
                </button>
              </td>
            </tr>
            <!-- Reassign expansion row -->
            <tr :key="`${i}-reassign`" v-if="reassigningProductId === i">
              <td :colspan="tableColumnCount" class="px-4 py-3 bg-white border-b border-gray-200">
                <div class="flex gap-3 mb-1 text-xs text-gray-400 font-medium">
                  <div class="flex-1">Reassign to product</div>
                </div>
                <div class="flex flex-col sm:flex-row gap-3 items-start">
                  <!-- Product search -->
                  <div class="flex-1 relative z-50">
                    <input
                      v-model="reassignSearch"
                      type="text"
                      placeholder="Search products…"
                      class="w-full text-sm border border-gray-300 rounded px-3 py-1.5 focus:outline-none focus:border-gray-500"
                    />
                    <div
                      v-if="reassignSearch && filteredProductsForReassign().length > 0"
                      class="absolute left-0 top-full mt-1 w-full bg-white border border-gray-200 rounded shadow-lg z-50 max-h-40 overflow-y-auto"
                    >
                      <div
                        v-for="prod in filteredProductsForReassign()"
                        :key="prod.id"
                        @click="selectProductForReassign(prod)"
                        class="px-3 py-2 text-sm hover:bg-gray-100 cursor-pointer border-b border-gray-100 last:border-0"
                      >
                        {{ prod.name }}
                      </div>
                    </div>
                    <div v-if="reassignSelectedProductId" class="mt-1 flex items-center gap-1 text-xs text-green-700 font-medium">
                      <span>✓ {{ productName(reassignSelectedProductId) }}</span>
                      <button @click="reassignSelectedProductId = null; reassignSearch = ''" class="ml-1 text-gray-400 underline">clear</button>
                    </div>
                  </div>
                  <!-- Save / Cancel buttons -->
                  <div class="flex gap-2 flex-shrink-0 items-start">
                    <button
                      @click="saveReassign()"
                      :disabled="!reassignSelectedProductId || reassignSaving"
                      class="px-3 py-1.5 rounded text-sm font-semibold text-white transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
                      :class="reassignSelectedProductId ? 'bg-gray-700 hover:bg-gray-800' : 'bg-gray-400'"
                    >
                      {{ reassignSaving ? 'Saving…' : 'Save' }}
                    </button>
                    <button
                      @click="cancelReassign()"
                      class="px-3 py-1.5 rounded text-sm font-medium text-gray-500 hover:bg-gray-100 transition-colors"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </td>
            </tr>
            </template>
          </tbody>
        </table>
      </div>
    </report-table>
    <!-- ── Needs Review: unmatched scan items ─────── -->
    <div v-if="unknownItems.length > 0 && (isAdmin || isManager)" class="w-full mt-6">
      <div class="flex items-center gap-2 mb-3">
        <span class="text-sm font-bold text-amber-700 uppercase tracking-wide">Needs Review</span>
        <span class="text-xs bg-amber-100 border border-amber-300 text-amber-700 rounded-full px-2 py-0.5 font-semibold">
          {{ unknownItems.length }}
        </span>
      </div>
      <div class="space-y-2">
        <div
          v-for="item in unknownItems"
          :key="item.key"
          class="rounded-lg border border-amber-200 bg-amber-50"
        >
          <!-- Item summary -->
          <div class="px-4 py-3">
            <div class="text-sm font-semibold text-gray-800">{{ item.name }}</div>
            <div class="flex flex-wrap items-center gap-x-3 gap-y-0.5 mt-1 text-xs text-gray-500">
              <span v-if="item.vendorCode" class="font-mono">#{{ item.vendorCode }}</span>
              <span v-if="item.packSize">{{ item.packSize }}</span>
              <span v-if="item.unitPriceCents">${{ (item.unitPriceCents / 100).toFixed(2) }}/unit</span>
              <span>{{ item.action }} &middot; Qty {{ Math.abs(item.amountReceived || 0) }}</span>
            </div>
          </div>
          <!-- Assignment controls -->
          <div v-if="unknownEdits[item.key]" class="border-t border-amber-200 px-4 py-3 bg-white rounded-b-lg">
            <!-- Column labels -->
            <div class="flex gap-3 mb-1 text-xs text-gray-400 font-medium">
              <div class="flex-1">Assign to product</div>
              <div class="w-28 text-center flex-shrink-0">Unit cost</div>
              <div class="w-32 text-center flex-shrink-0">Qty per unit</div>
            </div>
            <div class="flex flex-col sm:flex-row gap-3 items-start">
              <!-- Product search — z-50 so dropdown escapes its stacking context -->
              <div class="flex-1 relative z-50">
                <input
                  v-model="unknownEdits[item.key].search"
                  type="text"
                  placeholder="Search products to assign…"
                  class="w-full text-sm border border-gray-300 rounded px-3 py-1.5 focus:outline-none focus:border-gray-500"
                />
                <div
                  v-if="unknownEdits[item.key].search && filteredProductsForUnknown(item.key).length > 0"
                  class="absolute left-0 top-full mt-1 w-full bg-white border border-gray-200 rounded shadow-lg z-50 max-h-40 overflow-y-auto"
                >
                  <div
                    v-for="prod in filteredProductsForUnknown(item.key)"
                    :key="prod.id"
                    @click="selectProductForUnknown(item.key, prod)"
                    class="px-3 py-2 text-sm hover:bg-gray-100 cursor-pointer border-b border-gray-100 last:border-0"
                  >
                    {{ prod.name }}
                  </div>
                </div>
                <div v-if="unknownEdits[item.key].selectedProductId" class="mt-1 flex items-center gap-1 text-xs text-green-700 font-medium">
                  <span>✓ {{ productName(unknownEdits[item.key].selectedProductId) }}</span>
                  <button @click="clearProductForUnknown(item.key)" class="ml-1 text-gray-400 underline">clear</button>
                </div>
              </div>
              <!-- Unit cost (pre-filled from scan) -->
              <div class="w-28 flex-shrink-0">
                <money
                  class="w-full text-center border border-gray-300 rounded px-3 py-1.5 text-sm focus:outline-none"
                  v-model="unknownEdits[item.key].cost"
                  v-bind="moneyConfig"
                  autocomplete="off"
                />
              </div>
              <!-- Conversion factor + unit -->
              <div class="w-32 flex flex-col items-center flex-shrink-0">
                <input
                  type="number"
                  min="0.001"
                  step="0.001"
                  v-model.number="unknownEdits[item.key].conversionFactor"
                  class="w-full text-center border border-gray-300 rounded px-3 py-1.5 text-sm focus:outline-none focus:border-gray-500 no-arrow"
                  title="How many inventory units equal 1 vendor unit (e.g. 6 if 1 case = 6 each)"
                />
                <span class="text-xs text-gray-400 w-full text-center truncate mt-0.5">
                  {{ (products[unknownEdits[item.key].selectedProductId] || {}).unit || '—' }}
                </span>
              </div>
              <!-- Buttons -->
              <div class="flex gap-2 flex-shrink-0">
                <button
                  @click="resolveUnknownItem(item.key)"
                  :disabled="!unknownEdits[item.key].selectedProductId || unknownEdits[item.key].saving"
                  class="px-3 py-1.5 rounded text-sm font-semibold text-white transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
                  :class="unknownEdits[item.key].selectedProductId ? 'bg-gray-700 hover:bg-gray-800' : 'bg-gray-400'"
                >
                  {{ unknownEdits[item.key].saving ? 'Saving…' : 'Assign' }}
                </button>
                <button
                  @click="dismissUnknownItem(item.key)"
                  :disabled="unknownEdits[item.key].saving"
                  class="px-3 py-1.5 rounded text-sm font-medium text-gray-500 hover:bg-gray-100 transition-colors"
                >
                  Dismiss
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal-selection @confirm="addProductToInvoice" />
    <modal-selection-vendor @confirm="createInvoiceAndSetSelection" />
    <modal-submit-order />
  </div>
</template>

<script>
import SButton from '@/components/Button'
import { Timestamp, firebase } from '@/firebase.js'
import { mapGetters, mapActions } from 'vuex'
import ModalSubmitOrder from '@/components/ModalSubmitOrder'
import {
  floatify,
  downloadCsv,
  eitherDate,
  toDate,
  toDateString,
  dateFix,
  format
} from '@/utils'
import ModalSelection from '@/components/ModalSelection'
import ModalSelectionVendor from '@/components/ModalSelectionVendor'
import ReportSelector from '@/components/ReportSelector'
import ReportTable from '@/components/ReportTable'
import Sparkline from '@/components/Sparkline'
import { Money } from 'v-money'
import { DateTime } from 'luxon'

export default {
  name: 'ReportsInvoices',
  data() {
    return {
      initialLoad: true,
      selection: null,
      actionsOpen: false,
      unknownEdits: {},
      reassigningProductId: null,
      reassignSearch: '',
      reassignSelectedProductId: null,
      reassignSaving: false,
      moneyConfig: {
        decimal: '.',
        thousands: ',',
        prefix: '$ ',
        suffix: '',
        precision: 2,
        masked: false
      }
    }
  },
  components: {
    ModalSubmitOrder,
    ModalSelectionVendor,
    ModalSelection,
    ReportSelector,
    ReportTable,
    Sparkline,
    SButton,
    Money
  },
  computed: {
    ...mapGetters('global', ['settingsInvoiceActions']),
    ...mapGetters('user', ['isAdmin', 'isManager', 'isDeveloper']),
    ...mapGetters('storeModule/invoices', [
      'invoices',
      'invoiceById',
      'invoicesOrdered',
      'productsCosts',
      'productsByInvoiceId',
      'invoiceCsvByInvoiceId'
    ]),
    ...mapGetters('storeModule/products', [
      'products',
      'productName',
      'sortProductIdsByProductName'
    ]),
    ...mapGetters('storeModule/vendors', ['vendorsActive', 'vendorName']),
    ...mapGetters('storeModule', [
      'productsNotInInvoiceByInvoiceId',
      'createOrderEmailBody'
    ]),
    doc() {
      return this.invoiceById(this.selection)
    },
    isAnyItemReturned() {
      if (!this.doc) return false
      return Object.values(this.doc).some(data => {
        return data && data.action
          ? String(data.action).startsWith('Returned')
          : false
      })
    },
    refundAmount() {
      let amount = 0
      if (this.isAnyItemReturned) {
        Object.values(this.doc).forEach(data => {
          if (
            data &&
            data.action &&
            String(data.action).startsWith('Returned')
          ) {
            if (data.amountReturned) amount += data.amountReturned * data.cost
          }
        })
      }
      return amount
    },
    isAnyItemWrongAmount() {
      if (!this.doc) return false
      return Object.values(this.doc).some(data => {
        return data && data.action
          ? String(data.action).startsWith('Discrepancy')
          : false
      })
    },
    productsNotInInvoice() {
      try {
        return this.productsNotInInvoiceByInvoiceId(this.selection)
      } catch {
        return []
      }
    },
    unknownItems() {
      if (!this.doc) return []
      const scanLines =
        (this.doc.autoReconciliation && this.doc.autoReconciliation.lines) || []
      return Object.entries(this.doc)
        .filter(
          ([key, val]) =>
            val &&
            typeof val === 'object' &&
            val.mispick === true &&
            key.startsWith('unknown-')
        )
        .map(([key, val]) => {
          const scanLine =
            scanLines.find(
              line =>
                line.suggestedNewProduct &&
                line.suggestedNewProduct.nameGuess === val.name
            ) || null
          const vendorCodeMatch =
            scanLine && scanLine.rawText
              ? scanLine.rawText.match(/^([A-Z]?\d+)\s/)
              : null
          return {
            key,
            ...val,
            vendorCode: vendorCodeMatch ? vendorCodeMatch[1] : null,
            packSize:
              scanLine && scanLine.suggestedNewProduct
                ? scanLine.suggestedNewProduct.packSizeGuess || null
                : null,
            unitPriceCents: scanLine ? scanLine.unitPriceCents || null : null
          }
        })
    },
    localOrderDate: {
      get() {
        try {
          return DateTime.fromSeconds(this.doc.orderDate.seconds).toJSDate()
        } catch {
          return null
        }
      },
      set(newValue) {
        if (
          newValue &&
          this.doc.orderDate &&
          DateTime.fromSeconds(this.doc.orderDate.seconds)
            .setZone('America/New_York')
            .toISODate() !==
            DateTime.fromJSDate(newValue)
              .setZone('America/New_York')
              .toISODate()
        ) {
          console.log('update orderDate')
          this.updateItem({
            id: this.selection,
            data: { orderDate: Timestamp.fromDate(newValue) }
          })
        }
      }
    },
    localDeliveryDate: {
      get() {
        try {
          return DateTime.fromSeconds(this.doc.deliveryDate.seconds).toJSDate()
        } catch {
          return null
        }
      },
      set(newValue) {
        if (
          newValue &&
          this.doc.deliveryDate &&
          DateTime.fromSeconds(this.doc.deliveryDate.seconds)
            .setZone('America/New_York')
            .toISODate() !==
            DateTime.fromJSDate(newValue)
              .setZone('America/New_York')
              .toISODate()
        ) {
          this.updateItem({
            id: this.selection,
            data: { deliveryDate: Timestamp.fromDate(newValue) }
          })
        }
      }
    },

    tableColumnCount() {
      return 10 + (this.isAnyItemWrongAmount ? 1 : 0) + (this.isAnyItemReturned ? 2 : 0)
    },
    localInvoiceDate: {
      get() {
        try {
          return DateTime.fromSeconds(this.doc.invoiceDate.seconds).toJSDate()
        } catch {
          return null
        }
      },
      set(newValue) {
        console.log('inside set localInvoiceDate')
        if (
          !this.doc.invoiceDate ||
          (newValue &&
            this.doc.invoiceDate &&
            DateTime.fromSeconds(this.doc.invoiceDate.seconds)
              .setZone('America/New_York')
              .toISODate() !==
              DateTime.fromJSDate(newValue)
                .setZone('America/New_York')
                .toISODate())
        ) {
          this.updateItem({
            id: this.selection,
            data: { invoiceDate: Timestamp.fromDate(newValue) }
          })
        }
      }
    }
  },
  watch: {
    selection() {
      this.unknownEdits = {}
      this.reassigningProductId = null
      this.reassignSearch = ''
      this.reassignSelectedProductId = null
      this.reassignSaving = false
    },
    unknownItems: {
      immediate: true,
      handler(items) {
        items.forEach(item => {
          if (!this.unknownEdits[item.key]) {
            this.$set(this.unknownEdits, item.key, {
              search: '',
              selectedProductId: null,
              cost: item.unitPriceCents ? item.unitPriceCents / 100 : 0,
              conversionFactor: 1,
              saving: false
            })
          }
        })
      }
    }
  },
  methods: {
    downloadCsv,
    eitherDate,
    dateFix,
    toDate,
    toDateString,
    format,
    filteredProductsForUnknown(key) {
      const edit = this.unknownEdits[key]
      if (!edit || !edit.search) return []
      const q = edit.search.toLowerCase()
      return Object.entries(this.products || {})
        .filter(([, p]) => p && p.name && p.name.toLowerCase().includes(q))
        .map(([id, p]) => ({ id, name: p.name }))
        .sort((a, b) => a.name.localeCompare(b.name))
        .slice(0, 8)
    },
    selectProductForUnknown(key, prod) {
      this.$set(this.unknownEdits[key], 'selectedProductId', prod.id)
      this.$set(this.unknownEdits[key], 'search', '')
      const qtyPerUnit = (this.products[prod.id] || {}).qtyPerUnit
      if (qtyPerUnit) {
        this.$set(this.unknownEdits[key], 'conversionFactor', qtyPerUnit)
      }
    },
    clearProductForUnknown(key) {
      this.$set(this.unknownEdits[key], 'selectedProductId', null)
      this.$set(this.unknownEdits[key], 'search', '')
    },
    async resolveUnknownItem(key) {
      const edit = this.unknownEdits[key]
      if (!edit || !edit.selectedProductId) return
      const existingEntry = this.doc[edit.selectedProductId]
      if (existingEntry && !existingEntry.mispick) {
        alert(
          `${this.productName(edit.selectedProductId)} is already on this invoice. Edit it directly in the table above.`
        )
        return
      }
      this.$set(this.unknownEdits[key], 'saving', true)
      try {
        const item = this.doc[key]
        const qty = Math.abs(item.amountReceived || 0)
        await this.updateItem({
          id: this.selection,
          data: {
            [edit.selectedProductId]: {
              productId: edit.selectedProductId,
              name: this.productName(edit.selectedProductId),
              mispick: true,
              amountReceived: item.amountReceived || 0,
              amountOrdered: item.amountOrdered || 0,
              amountBilled: item.amountBilled || 0,
              amountReturned: item.amountReturned || 0,
              action: item.action,
              returnReason: item.returnReason || null,
              photos: item.photos || [],
              cost: edit.cost || 0,
              totalCost: qty * (edit.cost || 0),
              conversionFactor: edit.conversionFactor || 1,
              vendorCode: item.vendorCode || null,
              packSize: item.packSize || null
            },
            [key]: firebase.firestore.FieldValue.delete()
          }
        })
        this.$delete(this.unknownEdits, key)
      } catch (e) {
        console.error('resolveUnknownItem error:', e)
        this.$set(this.unknownEdits[key], 'saving', false)
      }
    },
    async dismissUnknownItem(key) {
      if (!confirm('Remove this unknown item from the invoice?')) return
      await this.updateItem({
        id: this.selection,
        data: { [key]: firebase.firestore.FieldValue.delete() }
      })
    },
    startReassign(productId) {
      this.reassigningProductId = productId
      this.reassignSearch = ''
      this.reassignSelectedProductId = null
      this.reassignSaving = false
    },
    cancelReassign() {
      this.reassigningProductId = null
      this.reassignSearch = ''
      this.reassignSelectedProductId = null
    },
    filteredProductsForReassign() {
      if (!this.reassignSearch) return []
      const q = this.reassignSearch.toLowerCase()
      return Object.entries(this.products || {})
        .filter(([id, p]) => p && p.name && p.name.toLowerCase().includes(q) && id !== this.reassigningProductId)
        .map(([id, p]) => ({ id, name: p.name }))
        .sort((a, b) => a.name.localeCompare(b.name))
        .slice(0, 8)
    },
    selectProductForReassign(prod) {
      this.reassignSelectedProductId = prod.id
      this.reassignSearch = ''
    },
    async saveReassign() {
      if (!this.reassigningProductId || !this.reassignSelectedProductId) return
      const existingEntry = this.doc[this.reassignSelectedProductId]
      if (existingEntry && existingEntry.productId) {
        alert(`${this.productName(this.reassignSelectedProductId)} is already on this invoice.`)
        return
      }
      this.reassignSaving = true
      try {
        const oldKey = this.reassigningProductId
        const newKey = this.reassignSelectedProductId
        const item = { ...this.doc[oldKey] }
        await this.updateItem({
          id: this.selection,
          data: {
            [newKey]: {
              ...item,
              productId: newKey,
              name: this.productName(newKey)
            },
            [oldKey]: firebase.firestore.FieldValue.delete()
          }
        })
        this.cancelReassign()
      } catch (e) {
        console.error('saveReassign error:', e)
        this.reassignSaving = false
      }
    },
    ...mapActions('storeModule/invoices', [
      'updateAmountReturnedByInvoiceIdByItemId',
      'updateAmountReceivedByInvoiceIdByItemId',
      'updateReturnReasonByInvoiceIdByItemId',
      'updateAmountBilledByInvoiceIdByItemId',
      'toggleInvoiceCompletedByInvoiceId',
      'updateActionByInvoiceIdByItemId',
      'updateInvoiceNumberByInvoiceId',
      'updateCostByInvoiceIdByItemId',
      'updateFeesByInvoiceId',
      'updateTaxByInvoiceId',
      'createInvoiceByVendorId',
      'addProductToInvoice',
      'resendEmail',
      'updateItem'
    ]),
    ...mapActions('storeModule/invoices', { deleteInvoice: 'delete' }),
    floatify,
    splice(str, beg, len) {
      let toStr = String(str)
      return toStr.splice(beg, len)
    },
    createInvoiceAndSetSelection(vendorId) {
      this.createInvoiceByVendorId(vendorId).then(
        newInvoiceId => (this.selection = newInvoiceId)
      )
    },
    viewScan() {
      const images = this.doc.scanImages
      if (images && images.length > 0) {
        images.forEach(img => window.open(img.downloadURL, '_blank'))
      } else if (this.doc.downloadURL) {
        window.open(this.doc.downloadURL, '_blank')
      }
    },
    changed(e) {
      console.log(e)
    },
    async newEmail() {
      this.$modal.show('modal--submit-order', {
        isInvoice: true,
        id: this.selection
      })
      // this.updateItem({
      //   id: this.selection,
      //   data: { email: this.createOrderEmailBody(this.doc.vendorId)(this.doc) }
      // }).then(this.resendEmail(e))
    }
  }
}
</script>

<style scoped>
.expand-enter,
.expand-leave-to {
  height: 0;
  opacity: 0;
}
.expand-enter-active {
  overflow: hidden;
  transition: height 0.25s 0.1s ease-out, opacity 0.2s 0.2s ease-out;
  /* //if multiple expands, use this one */
  /* //transition: height 0.25s 0.3s ease-out, opacity 0.3s 0.5s ease-out; */
}
.expand-leave-active {
  overflow: hidden;
  /* //if multiple expands, use this one */
  transition: opacity 0.05s ease-out, height 0.2s 0.1s ease-in;
}
</style>
